import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowedUsers } from "src/contexts"
import { useSegment } from "src/contexts/SegmentContext"
import { useUpdateDeviceSettings } from "src/hooks/deviceSettings"

export function useRemoveInsight() {
  const { currentDeviceSettings } = useFollowedUsers()
  const id = currentDeviceSettings.id
  const insights = currentDeviceSettings.insights

  const updateDeviceSettings = useUpdateDeviceSettings()

  const analyticsRef = useSegment()

  const removeInsight = useMemo(
    () => !updateDeviceSettings ? undefined : (insight: Insight) => {
      // TODO missing ID
      const data = {
        id,
        insights: insights.filter(
          (i: Insight) => i.key !== insight.key || i.range !== insight.range,
        ),
      }

      const response = updateDeviceSettings(data)

      void analyticsRef.current.track(
        "Insight Tile Removed",
        {
          "Tile Type": insight.key,
        },
      )

      return response
    },
    [
      analyticsRef,
      id,
      insights,
      updateDeviceSettings,
    ],
  )

  return removeInsight
}
